//スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});


//スクロールフェードイン
/* 到達したら要素を表示させる */
function showElementAnimation() {
	var element = document.getElementsByClassName('fadeIn');
	if(!element) return; // 要素がなかったら処理をキャンセル
						
	var showTiming = window.innerHeight > 768 ? 200 : 80; // 要素が出てくるタイミングはここで調整
	var scrollY = window.pageYOffset; //スクロール量を取得
	var windowH = window.innerHeight; //ブラウザウィンドウのビューポート(viewport)の高さを取得
					  
	for(var i=0;i<element.length;i++) { 
	  var elemClientRect = element[i].getBoundingClientRect(); 
	  var elemY = scrollY + elemClientRect.top; 
	  if(scrollY + windowH - showTiming > elemY) {
		element[i].classList.add('scrollin');
	  } else if(scrollY + windowH < elemY) {
	  // 上にスクロールして再度非表示にする場合はこちらを記述
		element[i].classList.remove('scrollin');
	  }
	}
}
showElementAnimation();
window.addEventListener('scroll', showElementAnimation);


//SVG
window.addEventListener('load', function(){
  deSVG('.desvg', true);
});


//ローディングアニメーション
//テキストのカウントアップ+バーの設定
$(function(){
	var bar = new ProgressBar.Line(splash_text, {//id名を指定
		easing: 'easeInOut',//アニメーション効果linear、easeIn、easeOut、easeInOutが指定可能
		duration: 1000,//時間指定(1000＝1秒)
		strokeWidth: 0.2,//進捗ゲージの太さ
		color: '#FFEBB1',//進捗ゲージのカラー
		trailWidth: 0.2,//ゲージベースの線の太さ
		trailColor: '#242424',//ゲージベースの線のカラー
		text: {//テキストの形状を直接指定				
			style: {//天地中央に配置
				position: 'absolute',
				left: '50%',
				top: '50%',
				padding: '0',
				margin: '-30px 0 0 0',//バーより上に配置
				transform:'translate(-50%,-50%)',
				//'font-size':'1rem',
				color: '#FFEBB1',
			},
			autoStyleContainer: false //自動付与のスタイルを切る
		},
		step: function(state, bar) {
			bar.setText(Math.round(bar.value() * 100) + ' %'); //テキストの数値
		}
	});
	//アニメーションスタート
	bar.animate(1.0, function () {//バーを描画する割合を指定します 1.0 なら100%まで描画します
		$("#splash_text").fadeOut(10);//フェイドアウトでローディングテキストを削除
		$(".loader_cover-up").addClass("coveranime");//カバーが上に上がるクラス追加
		$(".loader_cover-down").addClass("coveranime");//カバーが下に下がるクラス追加
		$("#splash").fadeOut();//#splashエリアをフェードアウト
	});
});



// 動きのきっかけとなるアニメーションの名前を定義
function fadeAnime(){
	// ふわっ
	$('.fadeTrigger').each(function(){ //fadeTriggerというクラス名が
	  var elemPos = $(this).offset().top-50;//要素より、50px上の
	  var scroll = $(window).scrollTop();
	  var windowHeight = $(window).height();
	  if (scroll >= elemPos - windowHeight){
	  $(this).addClass('fadeUp');// 画面内に入ったらfadeUpというクラス名を追記
	  }else{
	  $(this).removeClass('fadeUp');// 画面外に出たらfadeUpというクラス名を外す
	  }
	});
}
// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function(){
	fadeAnime();/* アニメーション用の関数を呼ぶ*/
});// ここまで画面が読み込まれたらすぐに動かしたい場合の記述

//ポップアップウィンドウ
$(function(){
	// 「.modal_open」をクリックしたらモーダルと黒い背景を表示する
	$('.modal_open').click(function(){
		// 黒い背景をbody内に追加
		$('body').append('<div class="modal_bg"></div>');
		$('.modal_bg').fadeIn();

		// data-targetの内容をIDにしてmodalに代入
		var modal = '#' + $(this).attr('data-target');
		
		// modalをフェードインで表示
		$(modal).fadeIn();
  
		// .modal_bgか.modal_closeをクリックしたらモーダルと背景をフェードアウトさせる
		$('.modal_bg, .modal_close').off().click(function(){
			$('.modal_box').fadeOut();
			$('.modal_bg').fadeOut('slow',function(){
				$('.modal_bg').remove();
			});
		});
	
		// .modal_switchを押すとモーダルを切り替える
		$('.modal_switch').click(function(){
			
			// 押された.modal_switchの親要素の.modal_boxをフェードアウトさせる
			$(this).parents('.modal_box').fadeOut();
			
			// 押された.modal_switchのdata-targetの内容をIDにしてmodalに代入
			var modal = '#' + $(this).attr('data-target');
			
			$(modal).fadeIn();
		});
	});
});

// キーを押したとき
$(window).on('keydown', function(e){
    var keyCode = e.keyCode;
    
    if(keyCode == 16 || keyCode == 44 || keyCode == 91 || keyCode == 92){
        $('img').hide();
        return false;
    }
});
 
// キーを離したとき
$(window).on('keyup', function(){
     $('img').show();
});